export const BUILDDATE = "2025-12-15 19:58:27";